import SvgAddressType from "./SvgAddressType";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";
export enum AddressTypes {
  home = "home_btn",
  work = "work_btn",
  other = "",
}
interface Props {
  btnType: AddressTypes;
  selected: boolean;
  onClick: () => void;
}

const AddressTypeButton: React.FC<Props> = ({ btnType, selected, onClick }) => {
  const t = useTranslation();
  return (
    <CustomButton
      type={selected ? BtnTypes.primary : BtnTypes.secondary}
      size={BtnSizes.option}
      radius={BtnRadius.small}
      onClick={onClick}
    >
      <SvgAddressType svgType={btnType} />
      {t[btnType !== AddressTypes.other ? btnType : "other_btn"]}
    </CustomButton>
  );
};

export default AddressTypeButton;
